var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleGradientStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8097 26.8174L15.2131 22.1771C15.141 22.1174 15.1833 22.0002 15.277 22.0002H22.4997L24.9066 14.7793C24.9369 14.6887 25.0647 14.688 25.096 14.7782L27.5975 22.0002H34.7228C34.8165 22.0002 34.8587 22.1173 34.7868 22.1771L29.2014 26.8174L30.9352 33.7424C30.9576 33.832 30.8571 33.9015 30.7812 33.849L25.0056 29.8503L19.2185 33.849C19.1425 33.9015 19.0421 33.8318 19.0647 33.7423L20.8097 26.8174Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.2697,
    y1: 10.0059,
    x2: 40.6411,
    y2: 19.9678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3158F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224659,
    stopColor: "#6868FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659007,
    stopColor: "#B45964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AF7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGradientStar);
export default __webpack_public_path__ + "static/media/circle-gradient-star.f1ccac37d4a83feebf017bb55c8a092f.svg";
export { ForwardRef as ReactComponent };